<script lang="ts" setup>
import { formatCurrency } from "@/utils/number";
import { CorporationSalarySummary } from "@/types/balance/BalanceHistory";
import { computed, PropType } from "vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";

const props = defineProps({
  isShowDetailModal: {
    type: Boolean,
    default: false
  },
  corporationSalarySummary: {
    type: Object as PropType<CorporationSalarySummary>,
    required: true
  }
});
const emits = defineEmits(["close"]);
const isShown = computed(() => props.isShowDetailModal);

function onClose() {
  emits("close");
}
</script>
<template>
  <BModal
    v-model="isShown"
    title="給与明細内訳"
    hide-footer
    centered
    class="detail-modal"
    @close="onClose"
    @hide="onClose"
  >
    <div v-if="corporationSalarySummary">
      <div class="office-summary">
        <div
          v-for="officeSalarySummary in corporationSalarySummary.officeSalarySummaries"
          :key="'office-summary' + officeSalarySummary.officeId"
          class="office-summary-item"
          data-testid="office-summary-item"
        >
          <div class="text-size-14" data-testid="office-label">
            {{ officeSalarySummary.name }}
          </div>
          <div class="pl-2 py-2">
            <div class="d-flex justify-content-between">
              <p class="text-mild text-size-14">報酬</p>
              <p class="text-mild text-size-14" data-testid="reward">
                {{ formatCurrency(officeSalarySummary.reward) }}
              </p>
            </div>
            <div class="d-flex justify-content-between mt-1">
              <p class="text-mild text-size-14">交通費</p>
              <p class="text-mild text-size-14" data-testid="option-value">
                {{ formatCurrency(officeSalarySummary.optionValue) }}
              </p>
            </div>
            <div class="d-flex justify-content-between mt-1">
              <p class="text-mild text-size-14">源泉徴収額</p>
              <p class="text-mild text-size-14" data-testid="withholding-tax">
                -&ensp;{{ formatCurrency(officeSalarySummary.withholdingTax) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2 px-1">
        <p class="text-size-16 text-weight-500">総計</p>
        <p
          class="text-blue text-size-16 text-weight-500"
          data-testid="total-income"
        >
          {{ formatCurrency(corporationSalarySummary.totalIncome) }}
        </p>
      </div>
      <AppButtonOutline
        block
        class="text-primary-dark text-weight-500 mt-3"
        @click="onClose"
        data-testid="close-button"
        >閉じる</AppButtonOutline
      >
    </div>
  </BModal>
</template>
<style lang="scss" scoped>
.office-summary {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $gray-03;
}

.office-summary-item {
  padding: 8px 4px;
  border-bottom: 1px solid $gray-03;
}
</style>
